import { Box, Card, CardContent, Tooltip, Typography } from "@mui/material";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const FinancialsCard = ({ financials, clientFinancials }) => {
  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Card
        sx={{
          borderRadius: "0.5rem",
          border: "none",
          boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08)",
          overflow: "hidden",
          bgcolor: "#ffffff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            bgcolor: "#003366",
            color: "#ffffff",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Tooltip
            title="Summarised financial strength and mandate economics relevant for investment discussions."
            arrow
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: "1.125rem",
                color: "#ffffff",
                cursor: "help",
              }}
            >
              Financials
            </Typography>
          </Tooltip>
          <DataSourceIcon mode="dark" sources={["Salesforce", "Nasdaq"]} />
        </Box>

        <CardContent sx={{ p: 2.5, flexGrow: 1 }}>
          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Total AUM with PFG
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "1rem" }}>
              {financials?.total_aum || "-"}
            </Typography>
          </Box>

          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              AUM Trend
            </Typography>
            <Typography
              sx={{ fontWeight: 600, fontSize: "0.9rem", color: "#16a34a" }}
            >
              {financials?.aum_trend_text || "-"}
            </Typography>
          </Box>

          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Operating Pool Liquidity Need
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
              {financials?.liquidity_need || "-"}
            </Typography>
          </Box>

          <Box sx={{ mb: 1.2 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Risk Flags
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
              {(financials?.risk_flags || []).join("; ")}
            </Typography>
          </Box>

          <Box sx={{ mb: 1.6 }}>
            <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
              Financial Health of Client
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
              External rating: {financials?.external_rating || "-"}
            </Typography>
          </Box>

          {/* CLIENT FINANCIAL METRICS */}
          <Box sx={{ mt: 0.5 }}>
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "#6c757d",
                textTransform: "uppercase",
                letterSpacing: 0.4,
                mb: 0.8,
              }}
            >
              Client Financials (FY2024)
            </Typography>

            {(clientFinancials || []).map((cf) => (
              <Box key={cf.metric} sx={{ mb: 1.0 }}>
                <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
                  {cf.metric}
                </Typography>
                <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
                  {cf.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FinancialsCard;
